import Home from "./Index";

const GatewayReport = () => {
  return <Home title='Report based on Gateway' url='gateway' />;
};

export default GatewayReport;
